import { trackerGet, trackerPost, trackerPostForm, trackerPut } from '../client';
import type { GeoCredentials, GeoDownloadResult, GeoStatus } from '../types';

export function geoStatus() {
  return trackerGet<GeoStatus>('/admin/geo/status');
}

export function geoCredentialsGet() {
  return trackerGet<GeoCredentials>('/admin/geo/credentials');
}

export function geoCredentialsPut(body: Partial<GeoCredentials>) {
  return trackerPut<GeoCredentials>('/admin/geo/credentials', body);
}

export function geoReload() {
  return trackerPost<{ status: string }>('/admin/geo/reload', {});
}

export function geoDownload(params: {
  maxmind?: boolean;
  ip2location?: boolean;
  ip2proxy?: boolean;
}) {
  return trackerPost<GeoDownloadResult>(
    '/admin/geo/download',
    {},
    {
      maxmind: params.maxmind ?? false,
      ip2location: params.ip2location ?? false,
      ip2proxy: params.ip2proxy ?? false,
    },
  );
}

export function geoUpload(filename: string, file: File) {
  const form = new FormData();
  form.append('filename', filename);
  form.append('file', file);
  return trackerPostForm<{ filename: string; size: number; status: string }>(
    '/admin/geo/upload',
    form,
  );
}
